import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { CollaborationSessions } from '../../helpers/schema';

export const schema = z.object({
  name: z.string().min(1, 'Name is required'),
  description: z.string().optional(),
  template: z.string().optional(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  session: Selectable<CollaborationSessions>;
};

export const createSession = async (body: InputType, init?: RequestInit): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/sessions/create`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
